import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";

import { PortalRoutesWrapper } from "@/app/components/auth";
import { IntakeFormContextProviderWrapper } from "@/features/intake-form/context";
import {
  AssessmentForm,
  ChooseJourney,
  SuccessScreen,
  VideoConsultation,
} from "../screens";
import { INTAKE_FORM_ROUTE } from "./constants";

export const getIntakeFormRoute = (): RouteObject => ({
  path: INTAKE_FORM_ROUTE.BASE,
  element: <PortalRoutesWrapper />,

  children: [
    {
      element: <IntakeFormContextProviderWrapper />,
      children: [
        { path: INTAKE_FORM_ROUTE.CHOOSE_JOURNEY, element: <ChooseJourney /> },

        {
          path: INTAKE_FORM_ROUTE.ASSESSMENT_FORM,
          element: <AssessmentForm />,
        },

        {
          path: INTAKE_FORM_ROUTE.SCHEDULE_VIDEO_CONSULTATION,
          element: <VideoConsultation />,
        },

        {
          path: INTAKE_FORM_ROUTE.SUCCESS,
          element: <SuccessScreen />,
        },

        {
          index: true,
          element: <Navigate replace to={INTAKE_FORM_ROUTE.CHOOSE_JOURNEY} />,
        },
        {
          path: "*",
          element: <Navigate replace to={INTAKE_FORM_ROUTE.BASE} />,
        },
      ],
    },
  ],
});
